import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import cx from 'classnames';

import arrow from 'assets/images/Marketplace/arrow.svg';

import styles from './HomePartnerNetworkSection.module.scss';

export default function HomePartnerNetworkSection() {
  const sliderRef: any = useRef();
  const [isAnimating, setIsAnimating] = useState(false);
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: -1,
    className: cx({
      [styles.animate]: isAnimating,
    }),
    beforeChange: () => setIsAnimating(true),
    afterChange: () => setIsAnimating(false),
  };

  const handleNextClick = () => {
    sliderRef?.current?.slickNext();
  };

  return (
    <div className={styles.partnerNetworkSection}>
      <div className="container">
        <div className="lending-title">Expand Your Partner Network:</div>
      </div>
      <Slider ref={sliderRef} {...settings}>
        <div className="slider-item">
          <div className={styles.sliderContent}>
            <span className={styles.sliderCount}>01</span>
            <div className={styles.sliderText}>
              Talent Acquisition marketplace for Top Staffing firms
            </div>
          </div>
        </div>
        <div className="slider-item">
          <div className={styles.sliderContent}>
            <span className={styles.sliderCount}>03</span>
            <div className={styles.sliderText}>
              Grow your business by delivering on New Partner Job Reqs
            </div>
          </div>
        </div>
        <div className="slider-item">
          <div className={styles.sliderContent}>
            <span className={styles.sliderCount}>02</span>
            <div className={styles.sliderText}>
              Target, Select & Partner with Quality Recruiters
            </div>
          </div>
        </div>
      </Slider>
      <div className={styles.sliderButtonBox}>
        <button className={styles.sliderButton} onClick={handleNextClick}>
          <img src={arrow} alt="" />
        </button>
      </div>
    </div>
  );
}
